// extracted by mini-css-extract-plugin
export default {"modal":"OR-z","modalOverlay":"PR-z","outfitHeading":"QR-z"};